module.exports = __webpack_public_path__ + "img/g7.3ded6d7b.jpg";